import React, { useState } from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import './admin.css';

const AdminLayout = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const menuItems = [
    { path: '/admin/dashboard', icon: 'bi-house-door', label: 'Dashboard' },
    { path: '/admin/analytics', icon: 'bi-graph-up', label: 'Analytics' },
    { path: '/admin/blogs', icon: 'bi-file-text', label: 'Blog Posts' },
    { path: '/admin/comments', icon: 'bi-chat-dots', label: 'Comments' },
    { path: '/admin/settings', icon: 'bi-gear', label: 'Settings' },
  ];

  const handleLogout = async () => {
    try {
      await logout();
      navigate('/admin/login');
    } catch (error) {
      console.error('Logout error:', error);
    }
  };

  const toggleSidebar = () => {
    setSidebarCollapsed(!sidebarCollapsed);
  };

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const getPageTitle = () => {
    const currentItem = menuItems.find(item => item.path === location.pathname);
    return currentItem ? currentItem.label : 'Admin Panel';
  };

  const getUserInitials = () => {
    if (user?.email) {
      return user.email.substring(0, 2).toUpperCase();
    }
    return 'AD';
  };

  return (
    <div className="admin-layout">
      {/* Sidebar */}
      <div className={`admin-sidebar ${sidebarCollapsed ? 'collapsed' : ''} ${mobileMenuOpen ? 'mobile-open' : ''}`}>
        <div className="sidebar-header">
          <h5 className="mb-0 fw-bold">Enteeon Admin</h5>
        </div>
        <nav className="sidebar-menu">
          {menuItems.map((item) => (
            <div
              key={item.path}
              className={`menu-item ${location.pathname === item.path ? 'active' : ''}`}
              onClick={() => {
                navigate(item.path);
                setMobileMenuOpen(false);
              }}
            >
              <div className="menu-icon">
                <i className={`bi ${item.icon}`}></i>
              </div>
              <span className="menu-text">{item.label}</span>
            </div>
          ))}
          <div className="menu-item" onClick={handleLogout}>
            <div className="menu-icon">
              <i className="bi bi-box-arrow-right"></i>
            </div>
            <span className="menu-text">Logout</span>
          </div>
        </nav>
      </div>

      {/* Topbar */}
      <div className={`admin-topbar ${sidebarCollapsed ? 'collapsed' : ''}`}>
        <div className="topbar-content">
          <div className="d-flex align-items-center">
            <button
              className="mobile-menu-toggle me-3"
              onClick={toggleMobileMenu}
            >
              <i className="bi bi-list"></i>
            </button>
            <button
              className="btn btn-link text-decoration-none p-0 d-none d-md-block"
              onClick={toggleSidebar}
            >
              <i className={`bi ${sidebarCollapsed ? 'bi-chevron-right' : 'bi-chevron-left'}`}></i>
            </button>
            <h1 className="page-title ms-3 mb-0">{getPageTitle()}</h1>
          </div>
          <div className="user-info">
            <button
              className="btn btn-outline-secondary me-3"
              onClick={() => navigate('/')}
              title="Back to Site"
            >
              <i className="bi bi-house-door me-1"></i>
              <span className="d-none d-sm-inline">Back to Site</span>
            </button>
            <span className="text-muted me-2 d-none d-sm-inline">{user?.email}</span>
            <div className="user-avatar">
              {getUserInitials()}
            </div>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <main className={`admin-main ${sidebarCollapsed ? 'collapsed' : ''}`}>
        <div className="container-fluid">
          <Outlet />
        </div>
      </main>

      {/* Mobile Overlay */}
      {mobileMenuOpen && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 bg-dark bg-opacity-50 d-md-none"
          style={{ zIndex: 999 }}
          onClick={() => setMobileMenuOpen(false)}
        ></div>
      )}
    </div>
  );
};

export default AdminLayout;